import { DateTime } from 'luxon';

export const dateFilter = (value: unknown) => {
    if (value) {
        const dt = DateTime.fromISO(String(value));
        return dt.toLocaleString(DateTime.DATETIME_MED);
    }
    return value;
};
